var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'text-common',
    ("text-common__" + _vm.typeText),
    _vm.isHover ? ("text-common__" + _vm.typeText + "_hover") :  '',
    _vm.disable ? ("text-common__" + _vm.typeText + "_hover") :  '' ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }